import { toast } from 'react-toastify';

export default class Notify {

  static error(message, error, options = {
    404: 'Não encontrado',
    500: 'Erro interno',
    409: 'Sua tela está desatualizada'
  }) {

    let cause = error && error.message;

    if (error) {
      if (error.response) {
        if (error.response.data) {
          cause = error.response.data.message
        }
      }
    }

    const messageToShow = message ? message + ': ' : '';
    toast.error(messageToShow + cause, {
      position: toast.POSITION.TOP_LEFT,
      theme: 'colored'
    });
  }

  static success(message) {
    toast.success(message, {
      position: toast.POSITION.TOP_CENTER,
      theme: 'colored'
    });
    return true;
  }

  static warning(message) {
    toast.warn(message, {
      position: toast.POSITION.TOP_CENTER,
      theme: 'colored'
    });
  }

  static showLoading(message) {
    toast.info(message, {
      position: toast.POSITION.TOP_CENTER,
      theme: 'colored'
    });
  }

  static promise(promise, messagesOptions) {
    return toast.promise(promise, {
      error: {
        render({ data }) {
          let cause = data && data.message;

          if (data && data.response && data.response.data) {
            cause = data.response.data.message
          } else {
            cause = "Erro desconhecido"
          }

          return `${messagesOptions.error}: ${cause}`
        },
        position: toast.POSITION.TOP_LEFT,
        theme: 'colored',
        type: 'error'
      },
      pending: {
        render() {
          return messagesOptions.pending
        },
        position: toast.POSITION.TOP_LEFT,
        theme: 'colored',
        type: 'info'
      },
      success: {
        render() {
          return messagesOptions.success
        },
        position: toast.POSITION.TOP_LEFT,
        theme: 'colored',
        type: 'success'
      }
    });
  }

  static dismissAll() {
    toast.dismiss()
  }
}



// WEBPACK FOOTER //
// ./src/services/Notify.js